import { api } from './index';
import type { ClinicalAuthor } from '../utils/clinical-author';
import type { ClinicalVoidable } from '../utils/clinical-void';

const BASE_PATH = '/api/internal/patient_documents';

export type PatientDocument = ClinicalVoidable & {
  id: number;
  patientId: number;
  name: string;
  documentUrl: string;
  edited: boolean;
  humanCreatedAt: string;
  author: ClinicalAuthor | null;
  // Its Autor may rename it within its 24-hour ventana de edición.
  canEdit: boolean;
}

export interface PatientDocumentForm {
  id?: number;
  patientId: number;
  name: string;
  document: File;
}

export interface PatientDocumentUdpateForm {
  id?: number;
  name: string;
}

export const patientDocumentsApi = {
  index(patientId: number): Promise<PatientDocument[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?patient_id=${patientId}`,
    }).then(response => response.data.patientDocuments);
  },
  create(patientDocumentForm: FormData): Promise<PatientDocument> {
    return api({
      method: 'post',
      url: BASE_PATH,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: patientDocumentForm,
    }).then(response => response.data.patientDocument);
  },
  update(patientDocumentForm: PatientDocumentUdpateForm): Promise<PatientDocument> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${patientDocumentForm.id}`,
      data: { patientDocument: patientDocumentForm },
    }).then(response => response.data.patientDocument);
  },
};
